<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">


    <el-dialog  title="Abstract Tag"
                :visible.sync="tagVisible"
                :close-on-click-modal="false"
                :center="true"
                width="400px"
                size="small"
                @closed ="closeTreeDialog"
                @opened="openAddTree">

      <tree-radio ref="abstractTree"></tree-radio>

      <span slot="footer" class="dialog-footer">

              <el-button type="success" @click="saveTree">Save</el-button>
              <el-button @click="tagVisible = false">close</el-button>
      </span>

    </el-dialog>

    <el-dialog
      title="Modify Field Tag"
      :visible.sync="addFieldTagDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="left"
        label-width="120px"
      >
        <el-form-item label="Field Name: "  required>
          <el-input v-model="fieldTagDTO.fieldName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Tag Name :"   >
          <el-row>
            <el-col :span="17">
            <el-input v-model="fieldTagDTO.tagName" size="small" :disabled="true"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="6">
              <el-button size="small" @click="chooseMyTree" >choose</el-button>
            </el-col>

          </el-row>

        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="addFieldTagDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  import treeRadio from '@/view/acs/tree/tree_radio.vue'
  import util from '@/util/util.js'

  export default {
    components: {
      treeRadio
    },
    data(){
      return{
        addFieldTagDialogVisible: false,
        fieldTagDTO:{
          //这里的id接受的是dbId
          id: "",
          fieldName: "",
          tagName:"",
          tagId:''
        },
        dataLoading: false,
        abstractTreeData:[],
        loadTreeFirstTime:true,
        abstractKeyData:{},
        tagVisible:false

      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      showDialog(row){
        //这里id 是dbId
        this.fieldTagDTO.id = row.id;
        this.addFieldTagDialogVisible = true;
      },
      hideDialog(){
        this.fieldTagDTO = {
          id: "",
          fieldName: "",
          tagId:"",
          tagName:''
        };
        this.addFieldTagDialogVisible = false;
      },
      save(){
        let url = this.baseAcsUrl + '/acs/table-field-tag-config/add-field';

        if(!this.fieldTagDTO.fieldName){
          this.$message.warning("fileName can not be empty");
          return;
        }
        this.dataLoading = true;
        this.http.post(url,this.fieldTagDTO).then(resp =>{
          this.$message.success('Successful operation ');
          this.addFieldTagDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
            this.$emit("saveFail");
             this.$message.warning('Operation failure');
          });
        },
        chooseMyTree(){
          this.tagVisible = true;
        },
        openAddTree(){
          if(this.loadTreeFirstTime){
            this.$refs.abstractTree.init(this.abstractTreeData,"tagName");
            this.$refs.abstractTree.setRadioId(this.fieldTagDTO.tagId);
          }else{
            this.$refs.abstractTree.setRadioId(this.fieldTagDTO.tagId);
          }

        },
      closeTreeDialog(){
        this.$refs.abstractTree.setRadioId("");
        this.loadTreeFirstTime = false;
      },
      initAbstractTreeData(treeData){
        this.abstractTreeData = util.deepClone(treeData);
      },
      saveTree(){
        let selectedAbstractTagId = this.$refs.abstractTree.getRadioId();
        let abstractKeyData = this.getAbstractData();
        if(selectedAbstractTagId){
          let actualData = this.abstractKeyData[selectedAbstractTagId];
          if(actualData){
            this.fieldTagDTO.tagId = actualData.id;
            this.fieldTagDTO.tagName = actualData.tagName;
          }

        }
        this.tagVisible = false;
      },
      getAbstractData(){
        if(this.abstractKeyData && JSON.stringify(this.abstractKeyData) != '{}'){

        }else{
          let data = {};
          this.getAbstractKeyData(data,this.abstractTreeData);
          this.abstractKeyData = data;
        }
        return this.abstractKeyData;
      },
      getAbstractKeyData(resultData,childrenData){
        if(childrenData && childrenData.length){
          for(var i in childrenData){
            let itemData = childrenData[i];
            if(itemData.id != 0 ||  !itemData.isService ){
              resultData[itemData.id] = itemData;
              let nextChildrenData = itemData.children;
              this.getAbstractKeyData(resultData,nextChildrenData);

            }
          }
        }
      },
      setFirstTime(){
        this.loadTreeFirstTime = true;
      }


    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/table/dialog/add_field_tag.vue